module.exports = __webpack_public_path__ + "static/pawel_zielinski-134f5840da143d4ec8d77d41370e29d2.jpeg";